import Home from './pages/Home';
import HotelBooking from './pages/HotelBooking';
import Travel from './pages/Travel';
import Fintech from './pages/Fintech';
import Gamification from './pages/Gamification';
import Loyalty from './pages/Loyalty';
import Ecommerce from './pages/Ecommerce';
import Engagement from './pages/Engagement';
import RegenFeed from './pages/RegenFeed';
import HomeIcon from '@mui/icons-material/Home';
import HotelIcon from '@mui/icons-material/Hotel';
import FlightIcon from '@mui/icons-material/Flight';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FeedIcon from '@mui/icons-material/Mms';
import FeedIcon2 from '@mui/icons-material/ChatBubbleOutline';

export const pages = [
  { name: 'Home', path: '/', icon: <HomeIcon />, element: <Home /> },
  { name: 'Hotel booking', path: '/hotel-booking', icon: <HotelIcon />, element: <HotelBooking /> },
  { name: 'Travel', path: '/travel', icon: <FlightIcon />, element: <Travel /> },
  { name: 'Fintech', path: '/fintech', icon: <AttachMoneyIcon />, element: <Fintech /> },
  { name: 'Gamification', path: '/gamification', icon: <SportsEsportsIcon />, element: <Gamification /> },
  { name: 'Loyalty', path: '/loyalty', icon: <CardGiftcardIcon />, element: <Loyalty /> },
  { name: 'E-commerce', path: '/ecommerce', icon: <ShoppingCartIcon />, element: <Ecommerce /> },
  { name: 'Regenerative Feed', path: '/regenfeed', icon: <FeedIcon2 />, element: <RegenFeed /> },
  { name: 'Engagement', path: '/engagement', icon: <FeedIcon />, element: <Engagement /> },
];
